import React, { Component } from 'react'
import Slider from 'react-slick'
import Http from '../shared/http'
import RiskProfileSlide from './RiskProfileSlide'
import RiskProfileResult from './RiskProfileResult'
import PropTypes from 'prop-types'
import RiskProfileData from './RiskProfileData'

export default class RiskProfileForm extends Component {
  static propTypes = {
    changeHeading: PropTypes.func.isRequired,
    tenant: PropTypes.string.isRequired,
    onboarding: PropTypes.bool.isRequired,
    scenarioPlanningResultsHandler: PropTypes.func,
    clientId: PropTypes.number.isRequired
  }

  riskProfileSlides;
  slider;
  questions = {};

  constructor(props) {
    super(props)

    this.state = {
      currentSlide: 0,
      totalSlides: 5
    }

    this.headingText = this.questionsText

    this.riskProfileSlides = RiskProfileData.questions.map((question, index) => {
      this.questions[question.id] = { answered: false, text: question.question }

      return (
        <div className='risk-slide-container' key={index}>
          <RiskProfileSlide question={question} onRadioButtonClicked={this.onRadioButtonClicked} />
        </div>
      )
    })
  }

  componentDidMount() {
    $(() => {
      this.disableNext()
      const nextButton = document.querySelector('#next-button')
      if (nextButton) {
        nextButton.classList.add('hide')
        nextButton.innerHTML = 'Done'
      }
    })
  }

  afterChange = (index) => {
    $('#pagination-numbers .current-position').text(index > 4 ? 5 : index + 1)
    if (this.questions[index + 1]) {
      this.changeHeading(false)
      this.hideResult()
    } else {
      this.handleResult()
      return
    }
    if (!this.questions[index + 1].answered) {
      this.disableNext()
    } else {
      this.enableNext()
    }
  }

  handleResult = () => {
    this.disablePrev()
    this.props.onboarding ? this.handleOnboardingResult() : this.handleScenarioPlanningResult()
  }

  handleOnboardingResult = () => {
    Http.request(`/clients/${this.props.clientId}/onboarding/calculate_risk`, `POST`, JSON.stringify(this.getFormattedQuestions()))
      .then((response) => response.json())
      .then((data) => {
        this.changeHeading(true)
        this.showResult(data.risk_results)

        // Use requestAnimationFrame to ensure DOM operations have settled
        // before showing the button. This fixes a race condition where clicking
        // "Done" too quickly after it appears would do nothing.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const nextButton = document.querySelector('#next-button')
            if (nextButton) {
              nextButton.classList.remove('hide')
              nextButton.innerHTML = 'Done'
            }
          })
        })
      })
      .catch((error) => {
        Sentry.captureException(error)
      })
  }

  handleScenarioPlanningResult = () => {
    const formattedAssessmentResults = this.getFormattedQuestions()
    this.props.scenarioPlanningResultsHandler(formattedAssessmentResults)
  }

  showResult = (risk_results) => {
    $('.slick-slider').remove()
    $('.onboardingui-body').append(`<div id='risk'>${risk_results}</div>`)
    $('#pagination-numbers, .slick-dots, .stairs-loader').hide()
    this.resultReady = true
  }

  hideResult = () => {
    $('#results-text').html(`<h2 className="loading-animation text-left">Calculating your risk profile</h2>`)
    this.resultReady = false
  }

  changeHeading = (finished) => {
    this.props.changeHeading(finished)
  }

  disableNext = () => {
    $('.slick-next').addClass('slick-disabled')
  }

  disablePrev = () => {
    $('.slick-prev').addClass('slick-disabled')
  }

  enableNext = () => {
    $('.slick-next').removeClass('slick-disabled')
  }

  onRadioButtonClicked = (question, answer) => {
    this.questions[question.id].answered = true
    this.questions[question.id].answer = answer
    this.slider.slickNext()
  }

  getFormattedQuestions = () => {
    let response = []

    for (let questionId in this.questions) {
      let question = this.questions[questionId]
      response.push({
        questionText: question.text,
        answerText: question.answer.text,
        answerValue: question.answer.value
      })
    }
    return {
      'risk': { 'assessment': response }
    }
  }

  render() {
    const settings = {
      dots: true,
      infinite: false,
      swipe: false,
      arrows: true,
      afterChange: this.afterChange
    }
    return (
      <div>
        <Slider ref={c => this.slider = c} {...settings}>
          {this.riskProfileSlides}
          <div>
            <RiskProfileResult
              resultReady={this.state.resultReady}
              resultText={this.state.resultText} />
          </div>
        </Slider>
        <div id='pagination-numbers'>
          <span className='current-position'>1</span>
          <span>/</span>
          <span>{this.state.totalSlides}</span>
        </div>
      </div>
    )
  }
}
